import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IOrderScheduleDetail
} from "../../../../../../utils/interfaces/tannery_production/order_schedule/IOrderScheduleDetail";


const useApiGetHistoricalCompanyOrderSchedule = (
    companyToken: string | undefined,
    data_inizio_storico?: string,
): UseQueryResult<IOrderScheduleDetail[], CustomAxiosError> => {

    const {get} = useApiCalls();

    async function doGet(company_token: string | undefined, data_inizio_storico?: string): Promise<IOrderScheduleDetail[]> {
        try {
            const params = data_inizio_storico ? {data_inizio_storico} : undefined;
            const response = await get(`/api/company/${company_token}/tannery_production/order_schedule/historical`, params);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ['useApiGetHistoricalCompanyOrderSchedule', data_inizio_storico],
        queryFn: () => doGet(companyToken, data_inizio_storico),
    })

};

export default useApiGetHistoricalCompanyOrderSchedule